import jsPDF from "jspdf";
import { IDespesaFullDTO } from "../../../models/happy-code-api.model";

export default function useEmitirReciboHook(){
  const gerarRecibo = (despesa: IDespesaFullDTO) => {
    const doc = new jsPDF();
  
    doc.setFontSize(16);
    doc.text("Recibo de Pagamento", 20, 20);
  
    doc.setFontSize(12);
    doc.text(`Descrição: ${despesa.dsDespesa}`, 20, 30);
    doc.text(`Valor Pago: R$ ${despesa.vlPago?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 20, 40);
    doc.text(`Data de Pagamento: ${new Date(despesa.dhPagamento).toLocaleDateString('pt-BR')}`, 20, 50);
    doc.text(`Status: Paga`, 20, 60);
    
    const marginTop = 10; 
    doc.line(20, 65 + marginTop, 180, 65 + marginTop); 

    const assinaturaTexto = "Assinatura do Responsável";
    const larguraTexto = doc.getStringUnitWidth(assinaturaTexto) * doc.getFontSize() / doc.internal.scaleFactor;
    const posX = (doc.internal.pageSize.width - larguraTexto) / 2;

    doc.text(assinaturaTexto, posX, 80 + marginTop); 

    doc.save(`recibo_${despesa.id}.pdf`);
  };

  return{
    gerarRecibo
  }
}
